/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import ConvoyDialog from "./ConvoyDialog";
import { Typography } from "@mui/material";

const ConfirmationDialog = ({
  isOpen,
  handleDialogConfirm,
  title,
  content,
  resetDialog,
}) => {
  if (!isOpen) {
    return <></>;
  }
  return (
    <ConvoyDialog
      open={isOpen}
      title={title || "Confirmation"}
      handleDialogConfirm={() => {
        handleDialogConfirm();
        resetDialog();
      }}
      resetDialog={resetDialog}
    >
      <Typography component="span" variant="h5">
        {content || ""}
      </Typography>
    </ConvoyDialog>
  );
};

export const useConfirmationDialog = (
  title,
  useApi,
  displayNotification,
  callback
) => {
  const { postData, response, responseStatus } = useApi();

  const [confirmationDialog, setConfirmationDialog] = useState({
    isOpen: false,
    title: "",
    content: "",
    handleDialogConfirm: () => {},
  });
  const resetDialog = () => {
    setConfirmationDialog({
      isOpen: false,
      title: "",
      content: "",
      handleDialogConfirm: () => {},
    });
  };

  useEffect(() => {
    displayNotification(response, responseStatus, callback);
  }, [response, responseStatus]);

  return {
    confirmationDialog: (
      <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        title={confirmationDialog.title}
        handleDialogConfirm={confirmationDialog.handleDialogConfirm}
        content={confirmationDialog.content}
        resetDialog={resetDialog}
      />
    ),
    showConfirmationDialog: (content, ...apiCallParams) => {
      setConfirmationDialog({
        isOpen: true,
        title,
        content,
        handleDialogConfirm: () => {
          postData(...apiCallParams);
          resetDialog();
        },
      });
    },
  };
};

export default ConfirmationDialog;
